// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageBar_container__2936D","language":"LanguageBar_language__2tRNd","active":"LanguageBar_active__3yBR0"};